import React from "react";
import { makeStyles } from '@mui/styles';
import Bubble from "./Bubble";

const useStyles = makeStyles(theme => ({
  dotsWrapper: {
    alignItems: "center",
    display: "flex",
    height: theme.spacing(2)
  },
  dot: {
    animation: `$mercuryTypingAnimation 1.5s ${
      theme.transitions.easing.easeInOut
    } infinite`,
    backgroundColor: "#90949c",
    borderRadius: "2px",
    display: "inline-block",
    height: "4px",
    marginRight: "2px",
    width: "4px",
    "&:nth-child(1)": {
      animationDelay: "200ms"
    },
    "&:nth-child(2)": {
      animationDelay: "300ms"
    },
    "&:nth-child(3)": {
      animationDelay: "400ms"
    }
  },
  "@keyframes mercuryTypingAnimation": {
    "0%": { transform: "translateY(0)" },
    "28%": { transform: "translateY(-5px)" },
    "44%": { transform: "translateY(0)" }
  }
}));

function Typing() {
  const classes = useStyles();
  return (
    <Bubble>
      <div className={classes.dotsWrapper}>
        <div className={classes.dot} />
        <div className={classes.dot} />
        <div className={classes.dot} />
      </div>
    </Bubble>
  );
}

export default Typing;
